import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import DuplicateSmall from 'wix-ui-icons-common/DuplicateSmall';
import UserJoinSmall from 'wix-ui-icons-common/UserJoinSmall';
import { reportDuplicateAndEditClick } from '../../redux/actions/bi.actions';
import { getIsSite } from '../../redux/selectors/config';
import { isBookingsStaffMember } from '../../services/roleService';
import { Box, Button } from 'wix-style-react';
import { getEnforceContributors } from '../../redux/actions/serverApi.actions';
import { EnforceContributorsButtonLoading } from '../EnforceContributors/EnforceContributors';
import * as s from './RolePageActionBar.scss';

interface IAppProps extends InjectedTranslateProps {
    id?: string;
    edit?: boolean;
    paddingTop?: string;

    onSaveAction(): void;
    onCancelAction(): void;
}

const RolePageActionBar: React.FC<IAppProps> = ({ t, id, edit, onSaveAction, onCancelAction, paddingTop }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isSite = useSelector(getIsSite);

    const [inviteButtonLoading, setInviteButtonLoading] = useState<boolean>(false);

    const onNavigation = useCallback((url, state?) => {
        history.push(url, state);
    }, [history]);

    const onDuplicateNavigation = useCallback(() => {
        onNavigation(`/role/new?duplicateId=${id}`, { biOrigin: '/role' });
        dispatch(reportDuplicateAndEditClick('/role', id));
    }, [id, onNavigation, dispatch]);

    const onAddPeopleAction = useCallback( async () => {
        setInviteButtonLoading(true);
        await dispatch(getEnforceContributors( { origin: '/role', roleIds: [id] }));
        setInviteButtonLoading(false);
    }, [id, dispatch]);

    return (
        <Box align="right" paddingTop={ paddingTop ? paddingTop : '' }>
            <Box minWidth={ edit ? '110px' : ''} paddingRight={'small'}>
                { edit ?
                  (<Button
                    dataHook={'role-page-cancel-button'}
                    priority={'secondary'}
                    onClick={onCancelAction}
                    fullWidth>
                    {t('role.cancel')}
                </Button>) :
                  (<Button
                    prefixIcon={<DuplicateSmall/>}
                    dataHook={'role-page-action-duplicate-and-edit'}
                    onClick={onDuplicateNavigation}
                    skin="inverted">
                      {t('rolesDetails.list.cells.edit')}
                  </Button>) }
            </Box>
            <Box width={ edit ? '110px' : ''}>
                { edit ?
                  (<Button
                    dataHook={'role-page-action-button'}
                    onClick={onSaveAction}
                    fullWidth>
                      {t('role.save')}
                  </Button>) :
                  (<Button
                    fullWidth
                    className={s.InviteButton}
                    prefixIcon={<UserJoinSmall style={{ visibility: inviteButtonLoading ?  'hidden' : 'initial' }}/>}
                    dataHook={'role-page-action-add-people'}
                    onClick={onAddPeopleAction}
                    skin="inverted"
                    disabled={isBookingsStaffMember(id)}>
                      <EnforceContributorsButtonLoading text={isSite ? t('role.site.inviteContributor') : t('role.account.inviteContributor')} isLoading={inviteButtonLoading}/>
                  </Button>)
                }
            </Box>
        </Box>
    );
};

export default React.memo(translate()(RolePageActionBar));
